import { useState } from 'react'
import { Spin } from 'antd'

export default function CoverDesignPage() {
  const [loading, setLoading] = useState(true)

  return (
    <div style={{ width: '100%', height: 'calc(100vh - 64px)', position: 'relative' }}>
      {loading && (
        <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: 10 }}>
          <Spin size="large" tip="加载封面设计工具..." />
        </div>
      )}
      <iframe
        src="/cover-design/index.html"
        style={{
          width: '100%',
          height: '100%',
          border: 'none',
          borderRadius: 0,
          display: 'block',
        }}
        title="封面设计工具"
        onLoad={() => setLoading(false)}
        sandbox="allow-scripts allow-same-origin allow-forms allow-downloads"
      />
    </div>
  )
}
